import { combineComparers } from '../../../../../../common/utils/comparer';
import {
  categoryFileComparer,
  moduleFileComparer,
  periodFileComparer,
  yearFileComparer,
} from '../../../utils/comparer';

export const periodHeaderComparer = combineComparers(
  periodFileComparer,
  yearFileComparer,
  moduleFileComparer,
  categoryFileComparer,
);

export const yearHeaderComparer = combineComparers(
  yearFileComparer,
  periodFileComparer,
  moduleFileComparer,
  categoryFileComparer,
);

export const moduleHeaderComparer = combineComparers(
  moduleFileComparer,
  yearFileComparer,
  periodFileComparer,
  categoryFileComparer,
);

export const categoryHeaderComparer = combineComparers(
  categoryFileComparer,
  yearFileComparer,
  periodFileComparer,
  moduleFileComparer,
);

export const defaultComparer = yearHeaderComparer;
